import React, { useEffect, useState } from "react";

import { Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import useCart from "../hooks/useCart";
import i18n from "../i18n";
import CartItemInfo from "./CartItemInfo.component";

const RecentCartItem = () => {
  const { t } = i18n;
  const [showRecentCartItem, setShowRecentCartItem] = useState(false);
  const langPrefix = getUrlLangPrefix();
  const { recentCartItem } = useCart();

  useEffect(() => {
    if (Object.keys(recentCartItem).length) {
      setShowRecentCartItem(true);
    }
  }, [recentCartItem]);

  return (
    <React.Fragment>
      {showRecentCartItem ? (
        <Modal
          animation
          backdropClassName="recent-item-backdrop"
          className="recent-item-modal"
          onHide={() => setShowRecentCartItem(false)}
          show={showRecentCartItem}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("item_has_been_added_to_your_card")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CartItemInfo item={recentCartItem} />
          </Modal.Body>
          <Modal.Footer>
            <NavLink
              className="d-grid gap-2"
              onClick={() => setShowRecentCartItem(false)}
              to={`${langPrefix}/${t("_route.cart")}`}
            >
              <Button variant="outline-primary">{t("view_cart")}</Button>
            </NavLink>
            <NavLink
              className="d-grid gap-2 mt-2"
              onClick={() => setShowRecentCartItem(false)}
              to={`${langPrefix}/${t("_route.shop")}`}
            >
              <Button variant="link">{t("continue_shopping")}</Button>
            </NavLink>
          </Modal.Footer>
        </Modal>
      ) : null}
    </React.Fragment>
  );
};

export default RecentCartItem;
